import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { useEffect } from "react";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));

function BranchWiseReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };
  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false)
  const [branchRpValues, setbranchRpValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: 'ALL',
  });
  const fromhandlechange = (e) => {
    setbranchRpValues({ ...branchRpValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setbranchRpValues({ ...branchRpValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setbranchRpValues({ ...branchRpValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
  }
  ///
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var branchid = '';
    if (branchRpValues.branch === 'ALL') {
      branchid = '-1'
    } else {
      branchid = branchRpValues.branch;
    }
    let details = { fromDate: branchRpValues.from, toDate: branchRpValues.to, employeeId: '-1', importer_iec_no: '-1', regionalId: branchid, flag: 2 }
    OperationReportService.getEmployeeReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails2(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportExcelClick = () => {
    setexportExcelProcs(true)
    if (!details2[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details2.length; i++) {
        if (details2[i].regionalName !== '') {
          tableContent = details2[i].regionalName + "!"
        } else {
          tableContent += '   !'
        }
        if (details2[i].consignmentNumber !== '') {
          tableContent += details2[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details2[i].invoiceDate !== '') {
          tableContent += details2[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].status !== '') {
          tableContent += details2[i].status + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,BRANCH WISE REPORT", headerDetails: "1,1,FROM DATE : " + branchRpValues.from + "/4,1,TO DATE : " + branchRpValues.to,
        tableHeader: "0,3,Sl.No/1,3,Branch Name/2,3,Job No/3,3,Job Date/4,3,Job Status",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "Branch", totalNumberOfColumn: 5, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportExcelProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);

  //tabel search
  const branchSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { branchOnchange(e.target.value) }} />
  }
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const jobStsSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobStsOnchange(e.target.value) }} />
  }
  //
  const branchOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobStsOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.status.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Typography color={"red"} fontWeight={"bolder"} variant={"h5"}>
              Branch Wise Report
            </Typography>
            <Row>
              <Col>
                <label style={mystyle1}>From Date</label></Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={branchRpValues.from} onChange={fromhandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>To Date</label></Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={branchRpValues.to} onChange={tohandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>Branch Name</label></Col>
              <Col>
                <Form.Select size="sm" style={mystyle} value={branchRpValues.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={showBtnClick}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={ExportExcelClick}>{exportExcelProcs ? 'processing...' : 'Export Excel'}</Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 420 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>Branch Name{branchSrch()}</StyledTableCell>
                      <StyledTableCell>Job No{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>Job Date</StyledTableCell>
                      <StyledTableCell>Job Status{jobStsSrch()}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.status}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default BranchWiseReport;
